import React from 'react';
import AgentDashboard from './AgentDashboard';

const OwensboroDashboard: React.FC = () => {
  const agentConfig = {
    id: 'owensboro2',
    displayName: 'Owensboro Production',
    icon: '/assets/logos/aldo-embroidery.png',
    color: '#ec4899',
    description: 'Owensboro production facility assistant',
    hasTestResults: false
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default OwensboroDashboard;

